var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplayed)?_c('iw-input-checkbox',{staticClass:"field",attrs:{"input-label":_vm.$t('heat_pump'),"name":"has-heat-pump"},model:{value:(_vm.hasHeatPump),callback:function ($$v) {_vm.hasHeatPump=$$v},expression:"hasHeatPump"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }